import { render } from "./SlideHeroItem.vue?vue&type=template&id=d274a518&scoped=true"
import script from "./SlideHeroItem.vue?vue&type=script&lang=js"
export * from "./SlideHeroItem.vue?vue&type=script&lang=js"

import "./SlideHeroItem.vue?vue&type=style&index=0&id=d274a518&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d274a518"]])

export default __exports__